import { render, staticRenderFns } from "./AddNewPaymentMethod.vue?vue&type=template&id=3271d739&scoped=true&"
import script from "./AddNewPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./AddNewPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./AddNewPaymentMethod.vue?vue&type=style&index=0&id=3271d739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3271d739",
  null
  
)

export default component.exports